import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class CalculoCoparticipacaoService extends Service {
  async consultarDemonstrativosNaoPagos (numDemonstrativo) {
    let demonstrativos = [];
    let result = await this.getCalculoCoparticipacaoApi().consultarDemonstrativosNaoPagos(numDemonstrativo);
    result.map(res => {
      const { numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado } = res;
      demonstrativos.push(Object.values({ numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado }));
    });
    return demonstrativos;
  }
  async consultarDemonstrativosNaoPagosOdonto (numDemonstrativo) {
    let demonstrativos = [];
    let result = await this.getCalculoCoparticipacaoApi().consultarDemonstrativosNaoPagosOdonto(numDemonstrativo);
    result.map(res => {
      const { numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado } = res;
      demonstrativos.push(Object.values({ numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado }));
    });
    return demonstrativos;
  }
  async calcularCoparticipacao (numDemonstrativo, procedimentos) {
    let result = await this.getCalculoCoparticipacaoApi().calcularCoparticipacao(numDemonstrativo, procedimentos);
    return result;
  }
  async calcularCoparticipacaoOdonto (numDemonstrativo) {
    let result = await this.getCalculoCoparticipacaoApi().calcularCoparticipacaoOdonto(numDemonstrativo);
    return result;
  }
  async getProcedimentos () {
    let procedimentos = await this.getCalculoCoparticipacaoApi().getProcedimentos();
    return procedimentos;
  }
  async lancarCoparticipacao () {
    let result = await this.getCalculoCoparticipacaoApi().lancarCoparticipacao();
    return result;
  }
}

export default CalculoCoparticipacaoService;
